module.exports = __webpack_public_path__ + "static/media/hero-haven.bafeaf2e.jpg";